const headersData = {
  headers: [
    {
      UIText: {
        "es-CL": { label: "Usuario" },
        "en-US": { label: "User" },
      },
      filterKey: "user",
      size: 3,
    },
    {
      UIText: {
        "es-CL": { label: "Dispositivo" },
        "en-US": { label: "Device" },
      },
      filterKey: "device",
      size: 3,
    },
    {
      UIText: {
        "es-CL": { label: "Repositorios" },
        "en-US": { label: "Repository" },
      },
      filterKey: "full_size",
      size: 3,
    },
    {
      UIText: {
        "es-CL": { label: "Tamaño" },
        "en-US": { label: "Size" },
      },
      filterKey: "full_size",
      size: 1.5,
    },
    {
      UIText: {
        "es-CL": { label: "Mas" },
        "en-US": { label: "More" },
      },
      filterKey: "",
      size: "grow",
      justify: "end",
    },
  ],
};

export default headersData;
